// extracted by mini-css-extract-plugin
export var arbiterBadgeContainer = "_1m-0";
export var colorSwatch = "_1m-5";
export var fillWidth = "_1m-4";
export var iconButton = "_1m-2";
export var iconWrapper = "_1m-3";
export var shadow = "_1m-6";
export var xs = "_1m-1";